/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { Button } from '@nike/eds';
import { Loading } from '@nike/frame-component-library';
import React, { useEffect, useState } from 'react';

import config from '../../config';
import { loadState } from '../../utils/local-storage';
import Modal from '../ccm/Modal';
import {
 ButtonSubmit, Creatable, StoreSelect, Table
} from '../reusable';

import edsCssJs from './eds.css.js';
import patch2css from './patch2.css.js';

const PatchContent = () => {
    const [isGtinSelected, setIsGtinSelected] = useState(true);
    const { accessToken } = loadState('auth');
    const [selectedCountry, setSelectedCountry] = useState({
        label: 'China',
        value: 'CHN',
      });
    const [formErrors, setFormErrors] = useState({
        codes: 'Required Field',
        selectedCountry: '',
    });

    const [codes, setCodes] = useState([]);

    const [isLoadingProductCatalogs, setIsLoadingProductCatalogs] = useState(false);
    const [productCatalogs, setProductCatalogs] = useState([]);
    const [groupProductCatalogsByStyleColor, setGroupProductCatalogsByStyleColor] = useState({});
    const [productCatalogsForPost, setProductCatalogsForPost] = useState([]);
    const [isProductCatalogPostCallCompleted, setIsProductCatalogPostCallCompleted] = useState(false);
    const [isGroupingModalOpen, setIsGroupingModalOpen] = useState(false);
    const [styleColorSelected, setStyleColorSelected] = useState('');
    const [productCatalogsNotFound, setProductCatalogsNotFound] = useState([]);

    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `${edsCssJs}\n${patch2css}`;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const handleGTINColumnClick = (d) => {
      if (isGtinSelected) {
        setIsGroupingModalOpen(true);
        setStyleColorSelected(d.styleColor);
      }
    };

    const handleSelectCountry = (country) => {
        setSelectedCountry(country);
    };

    const handleToggle = () => {
        setIsGtinSelected(!isGtinSelected);
        setCodes([]);
        setFormErrors({
            ...formErrors,
            codes: 'Required Field',
        });
        setProductCatalogs([]);
        setIsLoadingProductCatalogs(false);
        setIsProductCatalogPostCallCompleted(false);
        setProductCatalogsNotFound([]);
    };

    const handleCodeChange = (newCodes) => {
        setCodes(newCodes);
        setFormErrors({
            ...formErrors,
            codes: newCodes === null || newCodes.length === 0 ? 'Required Field' : '',
        });
    };

    const fetchProductCatalogs = async (country, ids) => {
        setIsProductCatalogPostCallCompleted(false);
        setIsLoadingProductCatalogs(true);
        setProductCatalogsForPost([]);
        setProductCatalogs([]);
        const url = `${config().rosHost}/patch`;
        const endpoint = isGtinSelected ? `?countryCode=${country}&gtins=${ids}` : `?countryCode=${country}&styleColor=${ids}`;
        const response = await fetch(`${url}${endpoint}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            method: 'GET',
        });
        const data = await response.json();
        if (isGtinSelected) {
          // set the productCatalogs with the data, only take one object per styleColor
          // get the set of object with unique styleColor
          const uniqueStyleColorObjects = data.reduce((acc, obj) => {
            const { styleColor } = obj;
            if (!acc.some((item) => item.styleColor === styleColor)) {
              acc.push(obj);
            }
            return acc;
          },
            []);
           setProductCatalogs(uniqueStyleColorObjects.map((item) => ({
            ...item,
            couponDiscountEnabled: item.couponDiscountEnabled ? 'True' : 'False',
            employeeDiscountCode: item.employeeDiscountCode === 3 ? 'Discountable' : 'Non-Discountable',
            id: item.gtin,
            itemDiscountCode: item.itemDiscountCode === 3 ? 'Discountable' : 'Non-Discountable',
            priceOverrideEnabled: item.priceOverrideEnabled ? 'True' : 'False',
            promotionEnabled: item.promotionEnabled ? 'True' : 'False',
            thresholdDiscountCode: item.thresholdDiscountCode === 3 ? 'Discountable' : 'Non-Discountable',
            transactionDiscountCode: item.transactionDiscountCode === 3 ? 'Discountable' : 'Non-Discountable',
          })));

          const groupedData = data.reduce((acc, obj) => {
            const { styleColor } = obj;
            if (!acc[styleColor]) {
              acc[styleColor] = [];
            }
            // set the couponDiscountEnabled, employeeDiscountCode, itemDiscountCode, priceOverrideEnabled, promotionEnabled, thresholdDiscountCode, transactionDiscountCode to the default values
            obj.couponDiscountEnabled = obj.couponDiscountEnabled ? 'True' : 'False';
            obj.employeeDiscountCode = obj.employeeDiscountCode === 3 ? 'Discountable' : 'Non-Discountable';
            obj.itemDiscountCode = obj.itemDiscountCode === 3 ? 'Discountable' : 'Non-Discountable';
            obj.priceOverrideEnabled = obj.priceOverrideEnabled ? 'True' : 'False';
            obj.promotionEnabled = obj.promotionEnabled ? 'True' : 'False';
            obj.thresholdDiscountCode = obj.thresholdDiscountCode === 3 ? 'Discountable' : 'Non-Discountable';
            obj.transactionDiscountCode = obj.transactionDiscountCode === 3 ? 'Discountable' : 'Non-Discountable';
            obj.id = obj.gtin;
            acc[styleColor].push(obj);
            return acc;
          }, {});
          setGroupProductCatalogsByStyleColor(groupedData);
            // setProductCatalogsNotFoundList
            // Find GTINs that were requested but not found in the response data
            const requestedGtins = ids.split(',').map((id) => id.trim());
            const foundGtins = data.map((item) => item.gtin);
            const notFoundGtins = requestedGtins.filter((gtin) => !foundGtins.includes(gtin));
            setProductCatalogsNotFound(notFoundGtins);
        } else {
          // get the set of object with unique styleColor
          const uniqueStyleColorObjects = data.reduce((acc, obj) => {
            const { styleColor } = obj;
            if (!acc.some((item) => item.styleColor === styleColor)) {
              acc.push(obj);
            }
            return acc;
          },
           []);
          // create a list of ProductCatalogs with the styleColor and default values for the other fields
          const productCatalogsWithStyleColor = Array.from(
            uniqueStyleColorObjects.map((item) => ({
              ...item,
              couponDiscountEnabled: item.couponDiscountEnabled ? 'True' : 'False',
              employeeDiscountCode: item.employeeDiscountCode === 3 ? 'Discountable' : 'Non-Discountable',
              id: item.styleColor,
              itemDiscountCode: item.itemDiscountCode === 3 ? 'Discountable' : 'Non-Discountable',
              priceOverrideEnabled: item.priceOverrideEnabled ? 'True' : 'False',
              promotionEnabled: item.promotionEnabled ? 'True' : 'False',
              thresholdDiscountCode: item.thresholdDiscountCode === 3 ? 'Discountable' : 'Non-Discountable',
              transactionDiscountCode: item.transactionDiscountCode === 3 ? 'Discountable' : 'Non-Discountable',
            }))
          );
          // set the productCatalogs state with the new list
          setProductCatalogs(productCatalogsWithStyleColor);
            // setProductCatalogsNotFoundList
            // Find styleColors that were requested but not found in the response data
            const requestedStyleColors = ids.split(',').map((id) => id.trim());
            const foundStyleColors = data.map((item) => item.styleColor);
            const notFoundStyleColors = requestedStyleColors.filter((styleColor) => !foundStyleColors.includes(styleColor));
            setProductCatalogsNotFound(notFoundStyleColors);
        }
        setIsLoadingProductCatalogs(false);
    };

    const handleOnTableRowChange = (row) => {
        const updatedProductCatalogs = productCatalogs.map((item) => {
            if (item.id === row.id) {
                return {
                    ...item,
                    couponDiscountEnabled: row.couponDiscountEnabled,
                    employeeDiscountCode: row.employeeDiscountCode,
                    itemDiscountCode: row.itemDiscountCode,
                    priceOverrideEnabled: row.priceOverrideEnabled,
                    promotionEnabled: row.promotionEnabled,
                    thresholdDiscountCode: row.thresholdDiscountCode,
                    transactionDiscountCode: row.transactionDiscountCode,
                };
            }
            return item;
        });
        setProductCatalogs(updatedProductCatalogs);
        const updatedProductCatalogsForPost = [...productCatalogsForPost];
        const index = updatedProductCatalogsForPost.findIndex((item) => item.id === row.id);
        if (index !== -1) {
            updatedProductCatalogsForPost[index] = {
                ...updatedProductCatalogsForPost[index],
                couponDiscountEnabled: row.couponDiscountEnabled === 'True',
                employeeDiscountCode: row.employeeDiscountCode === 'Discountable' ? 3 : 0,
                gtin: isGtinSelected ? row.id : undefined,
                itemDiscountCode: row.itemDiscountCode === 'Discountable' ? 3 : 0,
                priceOverrideEnabled: row.priceOverrideEnabled === 'True',
                promotionEnabled: row.promotionEnabled === 'True',
                styleColor: !isGtinSelected ? row.id : undefined,
                thresholdDiscountCode: row.thresholdDiscountCode === 'Discountable' ? 3 : 0,
                transactionDiscountCode: row.transactionDiscountCode === 'Discountable' ? 3 : 0,
            };
        } else {
            updatedProductCatalogsForPost.push({
                country: selectedCountry.value,
                couponDiscountEnabled: row.couponDiscountEnabled === 'True',
                employeeDiscountCode: row.employeeDiscountCode === 'Discountable' ? 3 : 0,
                gtin: isGtinSelected ? row.id : undefined,
                itemDiscountCode: row.itemDiscountCode === 'Discountable' ? 3 : 0,
                priceOverrideEnabled: row.priceOverrideEnabled === 'True',
                promotionEnabled: row.promotionEnabled === 'True',
                styleColor: !isGtinSelected ? row.id : undefined,
                thresholdDiscountCode: row.thresholdDiscountCode === 'Discountable' ? 3 : 0,
                transactionDiscountCode: row.transactionDiscountCode === 'Discountable' ? 3 : 0,
            });
        }
        setProductCatalogsForPost(updatedProductCatalogsForPost);
    };

    const handleSave = async () => {
      setIsLoadingProductCatalogs(true);
      setIsProductCatalogPostCallCompleted(false);
      const uniqueProductCatalogsForPost = Array.from(
        productCatalogsForPost
          .slice()
          .reverse()
          .reduce((map, current) => {
            const key = current.gtin || current.styleColor;
            if (!map.has(key)) {
              map.set(key, current);
            }
            return map;
          }, new Map())
          .values()
      );
      const url = `${config().rosHost}/patch`;
      const response = await fetch(url, {
        body: JSON.stringify({ request: uniqueProductCatalogsForPost }),
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        method: 'POST',
      });
      const data = await response.json();
      const successIds = data.success.map((item) => item.gtin || item.styleColor);
      const failureIds = data.failure.map((item) => item.gtin || item.styleColor);
      const updatedProductCatalogs = productCatalogs.map((item) => {
        if (successIds.includes(item.id)) {
          return {
            ...item,
            status: 'Success',
          };
        }
        if (failureIds.includes(item.id)) {
          return {
            ...item,
            status: 'Failure',
          };
        }
        return item;
      });
      setProductCatalogs(updatedProductCatalogs);
      setIsLoadingProductCatalogs(false);
      setIsProductCatalogPostCallCompleted(true);
    };

    const getColumnsForModal = () => {
        const columns = [
            {
                accessor: 'id',
                Header: 'GTIN',
            },
            {
                accessor: 'styleColor',
                Header: 'Style Color',
            },
            {
                accessor: 'couponDiscountEnabled',
                Header: 'Coupon Discount',
            },
            {
                accessor: 'employeeDiscountCode',
                Header: 'Employee Discount',
            },
            {
                accessor: 'itemDiscountCode',
                Header: 'Item Discount',
            },
            {
                accessor: 'priceOverrideEnabled',
                Header: 'Price Override',
            },
            {
                accessor: 'promotionEnabled',
                Header: 'Promotion',
            },
            {
                accessor: 'thresholdDiscountCode',
                Header: 'Threshold Discount',
            },
            {
                accessor: 'transactionDiscountCode',
                Header: 'Transaction Discount',
            },
        ];
        return columns;
    };
    const handleModalClose = () => {
        setIsGroupingModalOpen(false);
        setProductCatalogsNotFound([]);
    };

    const getColumns = () => {
        const columns = [
            {
                accessor: 'id',
                Cell: (d) => (
                  <button
                    id={d.original.styleColor}
                    type="button"
                    onClick={() => handleGTINColumnClick(d.original)}
                  >
                    {isGtinSelected ? `+ ${d.value}` : `${d.value}`}
                  </button>
                ),
                Header: isGtinSelected ? 'GTIN' : 'Style Color',
            },
            {
                accessor: 'couponDiscountEnabled',
                Cell: (d) => (
                  <label className="patch2-switch table-toggle-switch">
                    <input
                      checked={d.value === 'True'}
                      type="checkbox"
                      onChange={(e) => handleOnTableRowChange({ ...d.original, couponDiscountEnabled: e.target.checked ? 'True' : 'False' })}
                    />
                    <span className="patch2-slider table-toggle-slider" />
                  </label>
                ),
                Header: 'Coupon Discount',
            },
            {
                accessor: 'employeeDiscountCode',
                Cell: (d) => (
                  <label className="patch2-switch table-toggle-switch">
                    <input
                      checked={d.value === 'Discountable'}
                      type="checkbox"
                      onChange={(e) => handleOnTableRowChange({ ...d.original, employeeDiscountCode: e.target.checked ? 'Discountable' : 'Non-Discountable' })}
                    />
                    <span className="patch2-slider table-toggle-slider" />
                  </label>
                ),
                Header: 'Employee Discount',
            },
            {
                accessor: 'itemDiscountCode',
                Cell: (d) => (
                  <label className="patch2-switch table-toggle-switch">
                    <input
                      checked={d.value === 'Discountable'}
                      type="checkbox"
                      onChange={(e) => handleOnTableRowChange({ ...d.original, itemDiscountCode: e.target.checked ? 'Discountable' : 'Non-Discountable' })}
                    />
                    <span className="patch2-slider table-toggle-slider" />
                  </label>
                ),
                Header: 'Item Discount',
            },
            {
                accessor: 'priceOverrideEnabled',
                Cell: (d) => (
                  <label className="patch2-switch table-toggle-switch">
                    <input
                      checked={d.value === 'True'}
                      type="checkbox"
                      onChange={(e) => handleOnTableRowChange({ ...d.original, priceOverrideEnabled: e.target.checked ? 'True' : 'False' })}
                    />
                    <span className="patch2-slider table-toggle-slider" />
                  </label>
                ),
                Header: 'Price Override',
            },
            {
                accessor: 'promotionEnabled',
                Cell: (d) => (
                  <label className="patch2-switch table-toggle-switch">
                    <input
                      checked={d.value === 'True'}
                      type="checkbox"
                      onChange={(e) => handleOnTableRowChange({ ...d.original, promotionEnabled: e.target.checked ? 'True' : 'False' })}
                    />
                    <span className="patch2-slider table-toggle-slider" />
                  </label>
                ),
                Header: 'Promotion',
            },
            {
                accessor: 'thresholdDiscountCode',
                Cell: (d) => (
                  <label className="patch2-switch table-toggle-switch">
                    <input
                      checked={d.value === 'Discountable'}
                      type="checkbox"
                      onChange={(e) => handleOnTableRowChange({ ...d.original, thresholdDiscountCode: e.target.checked ? 'Discountable' : 'Non-Discountable' })}
                    />
                    <span className="patch2-slider table-toggle-slider" />
                  </label>
                ),
                Header: 'Threshold Discount',
            },
            {
                accessor: 'transactionDiscountCode',
                Cell: (d) => (
                  <label className="patch2-switch table-toggle-switch">
                    <input
                      checked={d.value === 'Discountable'}
                      type="checkbox"
                      onChange={(e) => handleOnTableRowChange({ ...d.original, transactionDiscountCode: e.target.checked ? 'Discountable' : 'Non-Discountable' })}
                    />
                    <span className="patch2-slider table-toggle-slider" />
                  </label>
                ),
                Header: 'Transaction Discount',
            },
        ];
        if (isProductCatalogPostCallCompleted) {
            columns.push({
                accessor: 'status',
                Cell: (d) => (
                  <span className={d.value === 'Success' ? 'success' : 'error'}>
                    {d.value}
                  </span>
                ),
                Header: 'Status',
            });
        }
        return columns;
    };

    return (
      <main className="ncss-col-sm-12">
        <article className="ncss-col-sm-12">
          <h1 className="ncss-h1"> Changes to a { isGtinSelected ? `GTIN` : `Style/Color` } are applied to all GTINs with in the Style/Color</h1>
        </article>
        <article className="ncss-col-sm-12">
          <article className="ncss-col-sm-6 va-sm-m mb1-sm" id="patch2-article-dropdown-parent">
            <StoreSelect
              isRequired
              noStores
              formErrors={formErrors}
              selectCountry={(country) => handleSelectCountry(country)}
              selectStore={() => { }}
              selectedCountry={selectedCountry}
            />
          </article>
          <article className="ncss-col-sm-6 va-sm-m ta-sm-l mb1-sm">
            <article className="patch2-toggle">
              <label className={isGtinSelected ? 'patch2-toggleLabel' : 'patch2-toggleLabelActive'} htmlFor="toggleSwitch">
                StyleColors
              </label>
              <label className="patch2-switch">
                <input
                  checked={!isGtinSelected}
                  type="checkbox"
                  onChange={handleToggle}
                />
                <span className="patch2-slider" />
              </label>
              <label className={isGtinSelected ? 'patch2-toggleLabelActive' : 'patch2-toggleLabel'} htmlFor="toggleSwitch">GTINs</label>
            </article>
          </article>
        </article>
        <article className="ncss-col-sm-12">
          <article className="ncss-col-sm-8 va-sm-m ta-sm-r mb1-sm">
            <Creatable
              isMulti
              errorMessage={formErrors.codes}
              label={isGtinSelected ? 'GTIN' : 'Style Color'}
              value={codes}
              width={8}
              onChange={(newCodes) => handleCodeChange(newCodes)}
            />
          </article>
          <article className="ncss-col-sm-4 va-sm-m ta-sm-l mb1-sm">
            <ButtonSubmit
              accessToken={accessToken}
              buttonText="Submit"
              formErrors={formErrors}
              isDisabled={codes === null || codes.length === 0 || selectedCountry.value === ''}
              onClick={() => fetchProductCatalogs(selectedCountry.value, codes.map((code) => code.value).join(','))}
            />
          </article>
        </article>
        <article className="ncss-col-sm-12">
          {isLoadingProductCatalogs && (
          <Loading />
            )}
          {!isLoadingProductCatalogs && productCatalogs.length > 0 && (
            <>
              <article className="ncss-col-sm-12" id="patch2-table-parent">
                <Table
                  columns={getColumns()}
                  data={productCatalogs}
                  fetched={productCatalogs.length > 0}
                  pageSize={productCatalogs.length > 10 ? 10 : productCatalogs.length}
                  showPagination={productCatalogs.length > 10}
                />
              </article>
              <article className="ncss-col-sm-12">
                <br />
                <Button disabled={productCatalogsForPost.length === 0} label="Save" onClick={() => { handleSave(); }}>
                  Save
                </Button>
              </article>
            </>
          )}
          {!isLoadingProductCatalogs && productCatalogs.length === 0 && (
            <article className="ncss-col-sm-12">
              <p className="body-1 pt4-sm text-color-accent">No Matches Found.</p>
            </article>
          )}
        </article>
        {isGroupingModalOpen && (
          <article className="ncss-col-sm-12" id="patch2-modal-parent">
            <Modal
              buttonName="Close"
              isOpen={isGroupingModalOpen}
              title="GTINs with common Style Color"
              onClose={handleModalClose}
            >
              <article className="ncss-col-sm-12" id="patch2-table-parent">
                <Table
                  columns={getColumnsForModal()}
                  data={groupProductCatalogsByStyleColor[styleColorSelected]}
                  fetched={groupProductCatalogsByStyleColor[styleColorSelected].length > 0}
                  pageSize={groupProductCatalogsByStyleColor[styleColorSelected].length}
                  showPagination={false}
                />
              </article>
            </Modal>
          </article>
        )}
        {
          productCatalogsNotFound.length > 0 && (
            <article className="ncss-col-sm-12">
              <Modal
                buttonName="Close"
                isOpen={productCatalogsNotFound.length > 0}
                title=""
                onClose={handleModalClose}
              >
                <article className="ncss-col-sm-12">
                  <h1 className="headline-3 text-color-accent mb3-sm">
                    {isGtinSelected ? `GTINs not found` : `Style Colors not found`}
                  </h1>
                  <br />
                  <ul>
                    {productCatalogsNotFound.map((item) => (
                      <li key={item} className="headline-5">{item}</li>
                     ))}
                  </ul>
                </article>
              </Modal>

            </article>
          )
        }
      </main>
    );
};

export default PatchContent;
